<template>
    <v-container>
      <v-form>
        <v-select
          v-model="selectedRegion"
          :items="displayedRegions"
          label="Select a region or country"
          item-text="label"
          item-value="code"
          @change="loadExistingValue"
          return-object
          dense
        ></v-select>
  
        <v-text-field
          v-if="selectedRegion"
          v-model="regionValues[selectedRegion.code]"
          :label="`Enter registration number for ${selectedRegion.name}`"
          @input="updateDisplayText"
          dense
        ></v-text-field>
      </v-form>
    </v-container>
  </template>
  
  <script>
  export default {
    data() {
      return {
        selectedRegion: null,
        regionValues: {},
        regions: [
          { code: 'EU', name: 'Europe' },
          { code: 'AU', name: 'Australia' },
          { code: 'UK', name: 'United Kingdom' },
        ],
      };
    },
    computed: {
      displayedRegions() {
        return this.regions.map((region) => {
          const value = this.regionValues[region.code];
          return {
            ...region,
            label: value ? `${region.name} (${value})` : region.name,
          };
        });
      },
    },
    methods: {
      loadExistingValue() {
        // When a region is selected, ensure its existing value is loaded
        this.$set(
          this.regionValues,
          this.selectedRegion.code,
          this.regionValues[this.selectedRegion.code] || ''
        );
      },
      updateDisplayText() {
        // Triggers re-evaluation of computed 'displayedRegions'
      },
    },
  };
  </script>
  
  <style scoped>
  .v-select,
  .v-text-field {
    max-width: 400px;
  }
  </style>
  